import { selectors as coreSelectors } from '$data/core';

import { fetchParticipants } from './participants.effects';
import {
  FETCH_PARTICIPANTS_STARTED,
  FETCH_PARTICIPANTS_SUCCESS,
  FETCH_PARTICIPANTS_FAILED,
} from './participants.types';

// eslint-disable-next-line import/prefer-default-export
export const fetchParticipantsInSpace = () => async (dispatch, getState) => {
  const state = getState();
  const spaceId = coreSelectors.getCurrentSpace(state).id;

  dispatch({
    type: FETCH_PARTICIPANTS_STARTED,
    spaceId,
  });

  try {
    const participants = await fetchParticipants({ spaceId });

    dispatch({
      type: FETCH_PARTICIPANTS_SUCCESS,
      participants,
      spaceId,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PARTICIPANTS_FAILED,
      error,
      spaceId,
    });
  }
};
